export default class GetName {
    constructor(options) {
        this.apiManager = options.apiManager;
        this.nameCache = new Map();
    }

    async getName(parameters) {
        if (!parameters.language) {
            throw new Error('Missing parameter language');
        }
        const params = {
            language: parameters.language
        };
        const result = {};
        let hasRemoteIds = false;
        ['fund', 'category', 'benchmark'].forEach(key => {
            if (parameters[key]) {
                const remoteSecIds = [];
                parameters[key].forEach(secId => {
                    const cacheName = this.nameCache.get(
                        `${secId}_${parameters.language}`
                    );
                    if (cacheName) {
                        result[secId] = cacheName;
                    } else {
                        remoteSecIds.push(secId);
                    }
                });
                if (remoteSecIds.length) {
                    hasRemoteIds = true;
                    params[key] = remoteSecIds;
                }
            }
        });
        if (!hasRemoteIds) {
            return result;
        }
        if (params.fund) {
            params.fund = params.fund.join(',');
        }
        if (params.category) {
            params.category = params.category.join(',');
        }
        if (params.benchmark) {
            params.benchmark = params.benchmark.join(',');
        }

        return this.apiManager.getName(params).then(res => {
            const data = res.Data;
            ['Fund', 'Category', 'Benchmark'].forEach(key => {
                if (data[key]) {
                    for (const id in data[key]) {
                        result[id] =
                            data[key][id][params.language] &&
                            data[key][id][params.language].legalName;
                        this.nameCache.set(
                            `${id}_${params.language}`,
                            result[id]
                        );
                    }
                }
            });
            return result;
        });
    }
}
